import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import DialogForm from '../../../Global/Modals/DialogForm';
import Button from '@material-ui/core/Button';
import { Formik, Field } from 'formik';
import OutlinedSelectInput from '../../../Global/Inputs/OutlinedSelect';

import combineStyles from '../../../../utils/combineStyles';
import ButtonStyles from '../../../../styles/button';
import SpacingStyles from '../../../../styles/helpers/spacing';
import { withNamespaces } from 'react-i18next';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
  formField: {
    paddingTop: theme.spacing.unit
  }
});
export class AddReferenceModal extends PureComponent {
  static propTypes = {
    open: PropTypes.bool.isRequired,
    availableFields: PropTypes.array.isRequired,
    onClose: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired
  };
  state = { selectedField: '' };
  _handleOnClose = () => {
    const { onClose } = this.props;
    this.setState({ selectedField: '' });
    onClose();
  };
  _handleChange = ({ target: { value } }) => {
    this.setState({ selectedField: value });
  };

  _handleOnSave = () => {
    const { selectedField } = this.state;
    const { availableFields, onSave } = this.props;

    const availableFieldIndex = availableFields.findIndex(field => {
      return field.stringId === selectedField;
    });
    onSave(availableFieldIndex);
    this._handleOnClose();
  };
  render() {
    const { availableFields, open, classes, t } = this.props;
    const { selectedField } = this.state;
    const selectOptions = availableFields.map(field => {
      return {
        title: field.label,
        value: field.stringId
      };
    });
    return (
      <Formik
        handleSubmit={this._handleOnSave}
        enableReinitialize={true}
        onSubmit={async (values, actions) => {
          actions.resetForm();
          this._handleOnSave(values);
        }}
        render={({ handleSubmit }) => (
          <DialogForm
            open={open}
            title={t('Add Reference Field')}
            onClose={() => {
              this._handleOnClose();
            }}
            footer={
              <Fragment>
                <div className={classes.spacer} />
                <Button
                  className={classes.button}
                  onClick={() => {
                    this._handleOnClose();
                  }}
                  color={'primary'}
                  classes={{ label: classes.buttonLabel }}
                >
                  {t('Cancel')}
                </Button>
                <Button
                  className={classes.button}
                  onClick={handleSubmit}
                  classes={{
                    disabled: classes.buttonDisabled,
                    label: classes.buttonLabel
                  }}
                  disabled={selectedField === ''}
                  color={'primary'}
                >
                  {t('Add')}
                </Button>
              </Fragment>
            }
          >
            <div className={classes.formField}>
              <Field
                name="availableFields"
                render={({ field, form }) => (
                  <OutlinedSelectInput
                    value={selectedField}
                    onChange={event => {
                      this._handleChange(event);
                    }}
                    field={field}
                    form={form}
                    label={t('Reference Field')}
                    options={selectOptions}
                  />
                )}
              />
            </div>
          </DialogForm>
        )}
      />
    );
  }
}

const translatedAddReferenceModal = withNamespaces()(AddReferenceModal);
export default withStyles(combineStyles(styles, ButtonStyles, SpacingStyles))(
  translatedAddReferenceModal
);
